<template>
    <div class="pt462" id="pt462">
        <breadcrumb :navListCustom="[{title:'マイページ', routerName: SiteConstants.PG010MAIN, param: {pageNo: '81'}}, {title:$t('pt120.labels.itemReviewTitle'), routerName: '', param: {}}]"></breadcrumb>
        <div class="">
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt430'"/>
            
            <div class="reviewListContainer" v-if="pt462DoInit.reviewList != null && pt462DoInit.reviewList.length > 0">
                <div class="reviewListTitle">
                    <span class="itemReviewTitle">
                        {{$t('pt120.labels.itemReviewTitle')}}
                    </span>
                    <span class="itemReviewEn">
                        {{$t('pt120.labels.itemReviewEn')}}
                    </span>
                </div>
                <div class="reviewListHeader" v-if="pt462DoInit.reqModel.processKbn == '2'">
                    <span class="nickName">
                        {{$t('pt120.labels.reviewKokyakuGroup')}}
                        {{pt462DoInit.nickName}}
                    </span>
                    &nbsp;
                    <span class="reviewKokyakuGroup" v-if="pt462DoInit.kokyakuGroup">
                        {{pt462DoInit.kokyakuGroup}}
                    </span>
                    <span class="kokyakuAge" v-if="pt462DoInit.ageOpneFlg == 1 && pt462DoInit.kokyakuAge">
                        <span v-if="pt462DoInit.kokyakuAge < 10 ">{{$t('pt120.labels.Oblique')}}00{{$t('pt120.labels.ageAfterWord')}}</span>
                        <span v-else-if="pt462DoInit.kokyakuAge >= 100 ">{{$t('pt120.labels.Oblique')}}{{pt462DoInit.kokyakuAge.toString().substring(1,2)}}0{{$t('pt120.labels.ageAfterWord')}}</span>
                        <span v-else>{{$t('pt120.labels.Oblique')}}{{pt462DoInit.kokyakuAge.toString().substring(0,1)}}0{{$t('pt120.labels.ageAfterWord')}}</span>
                    </span>
                    <span class="kokyakuSex" v-if="pt462DoInit.sexOpneFlg == 1 && pt462DoInit.kokyakuSexNm">
                        {{$t('pt120.labels.Oblique')}}{{pt462DoInit.kokyakuSexNm}}
                    </span>
                </div>
                <div class="reviewListHeader" v-else-if="pt462DoInit.reqModel.processKbn == '1'">
                    <span>{{$t('common.labels.productCode')}}:{{pt462DoInit.itemCd}} {{pt462DoInit.itemNm}}</span>
                </div>
                <template v-if="pt462DoInit.reqModel.processKbn == '1'">
                    
                    <div id="readMoreBlock">
                        <div class="reviewList readMoreInner" v-for="(reviewItem, index) in pt462DoInit.reviewList" :key="index">
                            <div class="readMoreContainer">
                                <div class="reviewItem">
                                    <div class="reviewItemHeader">
                                        <span class="reviewTitle">{{reviewItem.TITLE}}</span>
                                        &nbsp;
                                        <span class="nickName">
                                            {{$t('pt120.labels.reviewKokyakuGroup')}}
                                            {{reviewItem.NICKNAME}}
                                        </span>
                                        &nbsp;
                                        <span class="reviewKokyakuGroup" v-if="reviewItem.KOKYAKU_GROUP">
                                            {{reviewItem.KOKYAKU_GROUP}}
                                        </span>
                                        <span class="kokyakuAge" v-if="reviewItem.AGE_OPEN_FLG && reviewItem.KOKYAKU_AGE">
                                            <span v-if="reviewItem.KOKYAKU_AGE < 10 ">{{$t('pt120.labels.Oblique')}}00{{$t('pt120.labels.ageAfterWord')}}</span>
                                            <span v-else-if="reviewItem.KOKYAKU_AGE >= 100 ">{{$t('pt120.labels.Oblique')}}{{reviewItem.KOKYAKU_AGE.toString().substring(1,2)}}0{{$t('pt120.labels.ageAfterWord')}}</span>
                                            <span v-else>{{$t('pt120.labels.Oblique')}}{{reviewItem.KOKYAKU_AGE.toString().substring(0,1)}}0{{$t('pt120.labels.ageAfterWord')}}</span>
                                        </span>
                                        <span class="kokyakuSex" v-if="reviewItem.SEX_OPEN_FLG && reviewItem.KOKYAKU_SEX_KBN_NM">
                                            {{$t('pt120.labels.Oblique')}}{{reviewItem.KOKYAKU_SEX_KBN_NM}}
                                        </span>
                                        <span class="reviewItemStar">
                                            <template v-if="reviewItem.TOTALRANKAVG >= 1 && reviewItem.TOTALRANKAVG <= 10">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_0_5.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 11 && reviewItem.TOTALRANKAVG <= 20">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_1.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 21 && reviewItem.TOTALRANKAVG <= 30">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_1_5.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 31 && reviewItem.TOTALRANKAVG <= 40">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_2.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 41 && reviewItem.TOTALRANKAVG <= 50">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_2_5.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 51 && reviewItem.TOTALRANKAVG <= 60">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_3.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 61 && reviewItem.TOTALRANKAVG <= 70">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_3_5.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 71 && reviewItem.TOTALRANKAVG <= 80">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_4.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 81 && reviewItem.TOTALRANKAVG <= 90">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_4_5.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 91 && reviewItem.TOTALRANKAVG <= 100">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_5.png">
                                            </template>
                                        </span>
                                    </div>
                                    <div class="reviewItemContentInfo">
                                        <div class="reviewContent">
                                            <span :id="'reviewItemContent' + index" class="reviewItemContent" v-html="reviewItem.REVIEW" ></span>
                                        </div>
                                        <!--画像-->
                                        <div class="reviewImgContainer" v-if="reviewItem.IMAGE1 || reviewItem.IMAGE2 || reviewItem.IMAGE3">
                                            <div class="reviewImgList"  v-if="reviewItem.IMAGE1">
                                                <img class="reviewImg1" :src="reviewItem.IMAGE1" @error="getErrImage">
                                            </div>
                                            <div class="reviewImgList"  v-if="reviewItem.IMAGE2">
                                                <img class="reviewImg2" :src="reviewItem.IMAGE2" @error="getErrImage">
                                            </div>
                                            <div class="reviewImgList" v-if="reviewItem.IMAGE3">
                                                <img class="reviewImg3" :src="reviewItem.IMAGE3" @error="getErrImage">
                                            </div>
                                        </div>
                                        <div class="reviewDate">
                                            {{reviewItem.POST_YMD}}
                                        </div>
                                    </div>
                                </div>
                                <div class="reviewReplyInfo" v-if="reviewItem.REPLY_DISP_FLG == 1 && reviewItem.REPLY" >
                                    <div class="replayImageInfo">
                                        ↳<span class="reviewReplyContent" v-html="reviewItem.REPLY"/>
                                    </div>
                                    <div class="replyDate">
                                        {{reviewItem.REPLY_YMD}}
                                    </div>
                                </div>
                            </div>
                            <button class="readMoreBtn">
                                {{$t('pt120.labels.reviewItemReadAll')}}
                            </button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div id="readMoreBlock">
                        <div class="reviewList readMoreInner" v-for="(reviewItem, index) in pt462DoInit.reviewList" :key="index">
                            <div class="reviewItemTitle">
                                <div class="reviewItemTitleLink">
                                    <router-link :to="{ name: SiteConstants.PG030, params :{pageNo: 3, sItemNo: reviewItem.S_ITEM_CD}}">
                                        {{$t('common.labels.productCode')}}:{{reviewItem.S_ITEM_CD}} {{ reviewItem.ITEM_NM }}
                                    </router-link>
                                </div>
                                <div class="reviewItemTitleBtn" v-if="reviewItem.REVIEW_SYORI_KBN == 0 && pt462DoInit.currentKokyakuNo == reviewItem.KOKYAKU_NO">
                                    <input id="reviewEdit" :value="$t('common.buttons.edit')" type="button" class="reviewEdit" @click="gotoPt461(reviewItem.SEQ)">
                                </div>
                            </div>
                            <div class="readMoreContainer">
                                <div class="reviewItem">
                                    <div class="reviewItemHeader">
                                        <span class="reviewTitle">{{reviewItem.TITLE}}</span>
                                        &nbsp;
                                        <span class="reviewItemStar">
                                            <template v-if="reviewItem.TOTALRANKAVG >= 1 && reviewItem.TOTALRANKAVG <= 10">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_0_5.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 11 && reviewItem.TOTALRANKAVG <= 20">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_1.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 21 && reviewItem.TOTALRANKAVG <= 30">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_1_5.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 31 && reviewItem.TOTALRANKAVG <= 40">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_2.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 41 && reviewItem.TOTALRANKAVG <= 50">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_2_5.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 51 && reviewItem.TOTALRANKAVG <= 60">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_3.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 61 && reviewItem.TOTALRANKAVG <= 70">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_3_5.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 71 && reviewItem.TOTALRANKAVG <= 80">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_4.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 81 && reviewItem.TOTALRANKAVG <= 90">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_4_5.png">
                                            </template>
                                            <template v-if="reviewItem.TOTALRANKAVG >= 91 && reviewItem.TOTALRANKAVG <= 100">
                                                <img class="imgReviewItem" src="../img/icons/demo/star_5.png">
                                            </template>
                                        </span>
                                    </div>
                                    <div class="reviewItemContentInfo">
                                        <div class="reviewContent">
                                            <span :id="'reviewItemContent' + index" class="reviewItemContent" v-html="reviewItem.REVIEW" ></span>
                                        </div>
                                        <!--画像-->
                                        <div class="reviewImgContainer" v-if="reviewItem.REVIEW_PATH">
                                            <div class="reviewImgList"  v-if="reviewItem.IMAGE1">
                                                <img class="reviewImg1" :src="reviewItem.REVIEW_PATH + reviewItem.IMAGE1" @error="getErrImage">
                                            </div>
                                            <div class="reviewImgList"  v-if="reviewItem.IMAGE2">
                                                <img class="reviewImg2" :src="reviewItem.REVIEW_PATH + reviewItem.IMAGE2" @error="getErrImage">    
                                            </div>
                                            <div class="reviewImgList" v-if="reviewItem.IMAGE3">
                                                <img class="reviewImg3" :src="reviewItem.REVIEW_PATH + reviewItem.IMAGE3" @error="getErrImage">    
                                            </div>
                                        </div>
                                        <div class="reviewDate">
                                            {{reviewItem.POST_YMD}}
                                        </div>
                                    </div>
                                </div>
                                <div class="reviewReplyInfo" v-if="(reviewItem.REPLY_DISP_FLG == 1 || (reviewItem.OWN_KOKYAKU_NO == 1 && pt462DoInit.reqModel.processKbn == '0')) && reviewItem.REPLY" >
                                    <div class="replayImageInfo">
                                        ↳<span class="reviewReplyContent" v-html="reviewItem.REPLY"/>
                                    </div>
                                    <div class="replyDate">
                                        {{reviewItem.REPLY_YMD}}
                                    </div>
                                </div>
                            </div>
                            <button class="readMoreBtn">
                                {{$t('pt120.labels.reviewItemReadAll')}}
                            </button>
                        </div>
                    </div>
                </template>
            </div>
            <div v-else>
                <p class="mb32">
                    {{$t('pt462.labels.messgNoResult')}}
                </p>
            </div>
        </div>
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from "components/InputNumber";
import InputCheck from 'components/InputCheck.vue';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import PageFeed from "../commonParts/PageFeed";
import Loading from 'vue-loading-overlay';
export default {
    /* 
    * Name of component
    */
    name: "PT462ItemReviewListParts",

    /* 
    * Get data from parent component
    */
    components:
    {
		EventBus,
		Message,
		InputNumber,
        InputCheck,
        Loading,
        Breadcrumb,
        PageFeed,
    },
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            pt462DoInit:{},
            listIdErr:[],
            isPagingDisplay: false,
			pt462RespModel:{},
			SiteConstants: SiteConstants,
            listMessValid:[],
            mapMessValid:[],
            site: ""
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt462DoInit = _this.ptInitData;
            _this.pt462RespModel = _this.ptInitData.reqModel;
        }

        _this.$nextTick(() => {
            //商品レビューの全てを読むボタンの制御
            let reviewHeightLimit = this.pt462DoInit.reviewHeightLimit;
            let readmore = document.querySelectorAll('.readMoreInner');
            Array.from(readmore).forEach(function(more){

                let btn = more.querySelector('.readMoreBtn');
                let content = more.querySelector('.readMoreContainer');

                if(reviewHeightLimit > 0){
                    content.style.maxHeight = reviewHeightLimit + 'px';

                    // ボタンクリックでイベント処理
                    btn.addEventListener('click', () => {
                        if(!content.classList.contains('show')){
                            content.style.maxHeight = content.scrollHeight + 'px';
                            content.classList.add('show');
                            btn.innerText = _this.$i18n.t("pt120.labels.reviewItemReadClose");
                        } else {
                            content.style.maxHeight = reviewHeightLimit + 'px';
                            content.classList.remove('show');
                            btn.innerText = _this.$i18n.t("pt120.labels.reviewItemReadAll");
                        }
                    });

                    //表示直後は高さが不正確なので0.5秒後にボタン表示判定(高さ閾値以下ならボタン表示しない)
                    setTimeout(() => {
                        if(content.scrollHeight < reviewHeightLimit){
                            btn.style.display = 'none';
                        }
                    },500);
                }else{
                    btn.style.display = 'none';
                }
            });

        });
    },
    methods: {
		/**
         * レビュー画像パス
         */
         getReviewImg: function(imgPath, imgName){
            let path = "/easdocs/" + this.site + "/img";
            let imgPathPre  = "";
            let imgPathSuf = "";
            if (imgPath){
                if (imgPath[0] != "/"){
                    imgPathPre = "/";
                }
                if (!imgPath.endsWith('/')){
                    imgPathSuf = '/';
                }
            }
            path = path + imgPathPre + imgPath + imgPathSuf + imgName;
            
            return path;
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
         getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        gotoPt461: function(seq){
            this.$router.push({ name:this.SiteConstants.PG010MAIN,  query: { pageNo: 83}, params: {seq: seq}});
        }
    },
    /*
    * Excute code after an instance is created
    */
    created: function(){

    },
}
</script>
<style scoped>
#pt462 #readMoreBlock {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  gap: 30px;
}
#pt462 .readMoreInner {
  width: 100%;
  margin: 0 auto;
}
#pt462 .readMoreContainer {
  position: relative;
  height: auto;
  overflow: hidden;
  transition: max-height 0.5s;
}
#pt462 .readMoreBtn {
  display: block;
  margin: 0 auto;
  padding: 8px 20px;
  border: 0;
  color: black !important;
  background-color: transparent;
  cursor: pointer;
  letter-spacing: 0.13px;
}
#pt462 .readMoreBtn:focus {
  outline: 0px !important;
}
#pt462 .readMoreContainer p:last-child {
    margin-bottom: 10px;
}
  
</style>